'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var _typeof = _interopDefault(require('@babel/runtime/helpers/typeof'));

var callbackMap = new Map();
var getSize = function getSize() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return {
      width: undefined,
      height: undefined
    };
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};
var handleResize = function handleResize() {
  var size = getSize();
  callbackMap.forEach(function (callback) {
    return callback(size);
  });
};
var useWindowSize = (function (_ref) {
  var _ref$fixedSize = _ref.fixedSize,
    fixedSize = _ref$fixedSize === void 0 ? false : _ref$fixedSize;
  var _useState = React.useState(getSize),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  var _useRef = React.useRef({}),
    id = _useRef.current;

  // Effects only run on the client
  React.useEffect(function () {
    // Add the listener if this is the first one
    if (callbackMap.size === 0 && !fixedSize) {
      window.addEventListener('resize', handleResize);
    }
    callbackMap.set(id, function () {
      return setWindowSize(getSize());
    });
    return function () {
      callbackMap.delete(id);

      // Remove the listener if this is the last one
      if (callbackMap.size === 0) {
        window.removeEventListener('resize', handleResize);
      }
    };
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return windowSize;
});

exports.default = useWindowSize;
